<template>
  <div class="pagination-container">
    <button
      :disabled="!meta.prev_page_url"
      @click="changePage(meta.current_page - 1)"
      class="pagination-arrow"
    >
      <span class="material-symbols-outlined">chevron_left</span>
    </button>

    <div class="pagination-numbers">
      <button
        v-for="link in numericLinks"
        :key="link.label"
        @click="changePage(getPageNumber(link.url))"
        class="pagination-number"
        :class="{ active: link.active }"
      >
        {{ link.label }}
      </button>
    </div>

    <button
      :disabled="!meta.next_page_url"
      @click="changePage(meta.current_page + 1)"
      class="pagination-arrow"
    >
      <span class="material-symbols-outlined">chevron_right</span>
    </button>
  </div>
</template>

<script>
export default {
  props: {
    meta: {
      type: Object,
      required: true
    }
  },
  computed: {
    numericLinks() {
      return this.meta.links.filter(link => !isNaN(link.label));
    }
  },
  methods: {
    changePage(page) {
      if (page) {
        this.$emit("page-changed", page);
      }
    },
    getPageNumber(url) {
      const params = new URL(url).searchParams;
      return params.get("page");
    }
  }
};
</script>

<style scoped>
.pagination-container {
  display: flex;
  align-items: center;
  gap: 10px;
}

.per-page-selector {
  display: flex;
  align-items: center;
  gap: 5px;
  margin-right: 15px; /* Ok ve sayfa numaralarından ayırmak için */
}

label {
  font-size: 14px;
}

select {
  padding: 6px 10px;
  border: 1px solid #ddd;
  border-radius: 4px;
  cursor: pointer;
}


.pagination-arrow,
.pagination-number {
  padding: 6px 10px;
  border: 1px solid #ddd;
  background: #fff;
  cursor: pointer;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: background-color 0.3s, border-color 0.3s, color 0.3s;
}

.pagination-arrow {
  padding: 6px 6px;
}

.pagination-number.active {
  background: var(--logo-color);
  color: white;
  border-color: var(--logo-color);
  font-weight: 500;
}

.pagination-arrow:disabled,
.pagination-number:disabled {
  opacity: 0.5;
  cursor: not-allowed;
}

.pagination-arrow:hover:not(:disabled),
.pagination-number:hover:not(:disabled) {
  background: #f0f0f0;
  border-color: #bbb;
}

.pagination-arrow span {
  font-size: 16px;
}

.pagination-numbers {
  display: flex;
  gap: 5px;
}
</style>